module.exports = new __parcel__URL__("incidents-page-app-skeleton.tpl.5b656159.svg").toString();